import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowLeft, Building2, Phone } from "lucide-react";
import { PageHeader } from "@/components/page-header";
import { PageShell } from "@/components/page-shell";
import { Button } from "@/components/ui/button";
import { isSignedIn } from "@/lib/session";
import { useOrganization } from "@/lib/use-organization";

export const Route = createFileRoute("/help")({
  component: HelpPage,
});

function HelpPage() {
  const organization = useOrganization();
  const authed = isSignedIn();
  const backTo = authed ? "/steps" : "/";
  const backLabel = authed ? "Back to your steps" : "Back to sign in";
  const hasPhone = !!organization.main_phone_number;

  return (
    <PageShell>
      <PageHeader
        title="Help & support"
        description="Our team is happy to walk you through anything."
      />

      <div className="overflow-hidden rounded-2xl border border-border bg-gradient-to-br from-brand-tint via-card to-card p-6 shadow-[var(--shadow-card)]">
        <div className="flex items-start gap-3">
          {organization.logo_url ? (
            <img
              src={organization.logo_url}
              alt={organization.name}
              className="size-12 shrink-0 rounded-xl border border-border bg-card object-contain p-1.5"
            />
          ) : (
            <div className="flex size-12 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
              <Building2 className="size-6" />
            </div>
          )}
          <div className="min-w-0 flex-1">
            <p className="text-sm text-muted-foreground">
              {hasPhone
                ? "Need help? Call the team, and they'll walk you through anything."
                : "Reach out to the dealer directly — they can help you finish your application."}
            </p>
          </div>
        </div>

        {hasPhone && (
          <Button asChild size="lg" className="mt-5 w-full">
            <a href={`tel:${organization.main_phone_number}`}>
              <Phone className="size-4" />
              Call {organization.main_phone_number}
            </a>
          </Button>
        )}

        <Button
          asChild
          variant={hasPhone ? "ghost" : "default"}
          size="lg"
          className="mt-3 w-full"
          data-icon="inline-start"
        >
          <Link to={backTo}>
            <ArrowLeft className="size-4" />
            {backLabel}
          </Link>
        </Button>
      </div>
    </PageShell>
  );
}
